export default __webpack_public_path__ + "static/media/Attorney_Information.987460f1.pdf";